import React from "react";
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  Tooltip,
  ResponsiveContainer
} from "recharts";

interface ChartProps {
  data: {
    label: string;
    target: number;
    achieved: number;
  }[];
}

const TargetAchievedChart: React.FC<ChartProps> = ({ data }) => {
  return (
    <div className="bg-white rounded-xl shadow p-5 w-full h-full flex flex-col">
      <h2 className="text-lg font-semibold mb-4">Target vs Achieved</h2>

      <div className="w-full h-[250px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} barSize={35}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 13 }} />
            <Tooltip />
            <Bar dataKey="target" fill="#9acd32" name="Target" />
            <Bar dataKey="achieved" fill="#ff4db8" name="Achieved" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Legend */}
      <div className="flex items-center gap-6 mt-3">
        <div className="flex items-center gap-2">
          <span className="h-3 w-3 bg-[#9acd32] rounded"></span>
          <span className="text-sm">Target</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="h-3 w-3 bg-[#ff4db8] rounded"></span>
          <span className="text-sm">Achieved</span>
        </div>
      </div>
    </div>
  );
};

export default TargetAchievedChart;
